<template>
  <div class="themeElementContainer">
    <h5 class="subtitle" v-html="$t('views.themeView.globalRating.title')"></h5>
    <b-row class="radio-btn-row">
      <p class="title-radio" v-html="$t('views.themeView.globalRating.labelCheckbox')"></p>
      <b-form-radio-group :disabled="(mode=='print')" plain v-model="automatic" :options="options"></b-form-radio-group>
    </b-row>

    <!-- on affiche le slider si on a une note global ou si la personne souhaite définir manuellement la note -->
    <div class="quotation-container">
      <progress-bar
        :key="reRenderKey"
        v-if="(globalRating>0 || automatic==false) && mode!='print'"
        :themeAbbr="theme.abbreviation"
        :idRef="theme.ref"
        :disabled="false"
        :rating="globalRating"
        type="THEME"
        v-on:manualRating="setRadioBtn()"
      ></progress-bar>

      <progress-bar
        :key="reRenderKey"
        v-if="(globalRating>0 || automatic==false) && mode=='print'"
        :themeAbbr="theme.abbreviation"
        :idRef="theme.ref+'print'"
        :disabled="true"
        :rating="globalRating"
        type="PRINT"
      ></progress-bar>

      <span class="warning-msg" v-if="globalRating===null && automatic==true">
        <alert-icon title="" />{{$t('views.themeView.globalRating.automaticCalcWarning')}}
      </span>

      <info-message 
        v-if="nbSubThemesWaitingForRating>0 && !(globalRating===null && automatic==true)"
        :text="$tc('views.themeView.globalRating.subThemesWaitingForRatingWarning', nbSubThemesWaitingForRating, [nbSubThemesWaitingForRating])"
      />
  </div>
  </div>
</template>

<script>
import ProgressBar from "../ProgressBar";
import AlertIcon from 'vue-material-design-icons/Alert.vue';
import InfoMessage from "../global/InfoMessage";

export default {
  name: "GlobalRating",
  components: {
    ProgressBar,
    AlertIcon,
    InfoMessage
  },
  props: {
    theme: Object,
    ratingChanged: Number,
    mode: String // identifier qu'on est en mode impression
  },
  mounted: function() {
    // si aucune évaluation n'a encore été réalisée ou qu'on est en évaluation automatique, on calcul et on met à jour la note
    if (this.theme.globalRating.automatic) {
      this.generateGlobalRating();
    } else {
      this.globalRating = this.theme.globalRating.rating;
      this.automatic = false; // change l'affichage des boutons radio
    }
  },
  watch: {
    automatic: function() {
      if (this.automatic) {
        this.generateGlobalRating();
      }
    },
    ratingChanged: function() { // quand ratingChanged est modifié, cela signifie que la note globale doit être recalculée
      if (this.automatic) {
        this.generateGlobalRating();
      }
    }
  },
  data: function() {
    return {
      reRenderKey: 0,
      nbSubThemesWaitingForRating: 0,
      globalRating: 0,
      automatic: true,
      options: [
        {
          text: this.$i18n.t('views.themeView.globalRating.auto'),
          value: true
        },
        {
          text: this.$i18n.t('views.themeView.globalRating.manual'),
          value: false
        }
      ]
    };
  },
  methods: {
    generateGlobalRating: function() {
      this.nbSubThemesWaitingForRating = 0;
      var nbRatedSubThemes = 0;
      var sumOfRatings = 0;
      for (let i = 0; i < this.theme.subThemes.length; i++) {
        var rating = this.theme.subThemes[i].rating;
        if (rating !== null && rating >= 0) {
          sumOfRatings += rating;
          nbRatedSubThemes++;
        }
        else if (rating === null) {
          this.nbSubThemesWaitingForRating++;
        }
      }
      if (nbRatedSubThemes > 0) {
        // on calcule la moyenne automatiquement
        this.globalRating = Math.round(sumOfRatings / nbRatedSubThemes);
        
        // On évite les notes entre 2 niveaux en augmentant de 1 si nécessaire
        if (this.globalRating > 0 && this.globalRating % 25 == 0) {
          this.globalRating++;
        }
      } else {
        // Pas de calcul de moyenne possible si aucun sous-thème ne possède de note
        this.globalRating = null;
      }

      var newData = {
        type: "RATE-THEME",
        params: {
          themeAbbr: this.theme.abbreviation,
          rating: this.globalRating,
          automatic: true
        }
      };
      this.$store.dispatch("editThemeElement", newData);
      this.reRenderKey += 1; // on régénère le slider quand globalRating change
    },
    setRadioBtn: function() {
      this.automatic = false;
    }
  }
};
</script>

<style lang='sass' scoped>
@import "../../sass/_variables.sass"

h5.subtitle
  @media print
    font-family: pt_sans, Arial, "Helvetica Neue", Helvetica, sans-serif
    font-size: 1.3em
    color: $gray-3
    margin: 0.5em 0 0.25em 0
    padding: 0


.radio-btn-row
  margin-top: 1em
  padding-left: 15px
  
  .title-radio
    font-weight: bold
    margin-right: 2em

  ::v-deep .form-check
    margin: 0 1.5em 0 0

    &:last-child
      margin-right: 0


.quotation-container
  margin-right: 4em
  /*margin-left: 2em*/
</style>